import { queryOptions } from '@tanstack/react-query';
import useNotificationMutation from './notification.mutations';
import NotificationService from './notification.service';

interface IUseTemplate {
  createTemplate: any;
  modifyTemplate: any;
  deleteTemplate: any;
  isUpdatingTemplate: any;
  setIsUpdatingTemplate: any;
}

const useTemplate = (templateId?: number, customerId?: number): IUseTemplate => {
  const { createTemplate, modifyTemplate, deleteTemplate, isUpdatingTemplate, setIsUpdatingTemplate } = useNotificationMutation();

  return {
    createTemplate,
    modifyTemplate,
    deleteTemplate,
    isUpdatingTemplate,
    setIsUpdatingTemplate
  };
};

export const createTemplateDownloadByTemplateIdOptions = (templateId: number) => queryOptions<any>({
  queryKey: ['download-template-by-template-id', templateId],
  queryFn: async () => {
    const notificationService = NotificationService()
    if (!templateId) return new Promise((resolve) => resolve(null));
    return new Promise(async (resolve) => {
      await notificationService
        .getDownloadByTemplateId({
          templateId
        })
        .then((res) => {
          resolve(res);
        });
    });
  },
  staleTime: 1000 * 60 * 5, // 5 minutes
  refetchInterval: 1000 * 60 * 5, // 5 minutes
  enabled: !!templateId,
  refetchOnWindowFocus: false,
});


export default useTemplate;
